import PropTypes from "prop-types";
import {ErrorBoundary, useErrorBoundary} from "react-error-boundary";
import {useTranslation} from "react-i18next";
import {PrimaryButton} from "@/components/Button";
import {useLogo} from "../../../util/logoUtils";
import styles from "../ErrorBoundaryHandler.module.css";

const FallbackComponent = () => {
  const {t} = useTranslation();
  const {resetBoundary} = useErrorBoundary();
  const logoImg = useLogo(); // Dynamic logo based on hostname

  const handleErrorState = () => {
    window.location.href = "/";
    resetBoundary();
  };

  return (
    <div className={styles.error_boundary_container}>
      <img
        src={logoImg}
        alt="Logo"
        className={styles.errorBoundaryLogoImg}
      />
      <p className={styles.error_boundary_title}>{t("errorBoundaryHandler1")}</p>
      <p className={styles.error_boundary_action}>{t("errorBoundaryHandler2")}</p>
      <PrimaryButton onClick={handleErrorState}>{t("errorBoundaryBtnReload")}</PrimaryButton>
    </div>
  );
};

export const ErrorBoundaryHome = ({children}) => {
  return (
    <div>
      <ErrorBoundary FallbackComponent={FallbackComponent}>{children}</ErrorBoundary>
    </div>
  );
};

ErrorBoundaryHome.propTypes = {
  children: PropTypes.node,
};
